export function CurrencySwitcher({
  value,
  rate,
  onCurrencyChange,
  theme = "dark",
  loading = false,
}) {
  const isGBP = value === "GBP";
  const dark = theme === "dark";
  // Light theme mirrors the other Costs-tab action pills (Export in
  // Excel, Original PDF, Adjust samples): white background, stone
  // border, rounded-full, uppercase mono label, navy hover. Dark
  // theme is unchanged (used on the proposal hero band).
  const wrapCls = dark
    ? "no-print inline-flex items-center gap-2 bg-white/10 border border-white/15 rounded-lg px-3 py-1.5"
    : "no-print inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white px-4 py-2.5 hover:border-[#1B4F8A] transition-colors group";
  const labelCls = dark
    ? "text-xs text-stone-400 font-mono"
    : "text-[11px] font-mono tracking-[0.14em] uppercase text-stone-600 group-hover:text-[#1B4F8A] transition-colors";
  const selectCls = dark
    ? "bg-transparent text-sm text-white border-0 focus:outline-none cursor-pointer"
    : "bg-transparent text-[11px] font-mono tracking-[0.14em] uppercase font-semibold text-stone-700 group-hover:text-[#1B4F8A] border-0 focus:outline-none cursor-pointer transition-colors pr-0.5";
  const atCls = dark
    ? "text-xs text-stone-500"
    : "text-[10px] text-stone-400 font-mono";
  // Rate is auto-fetched (mid-market + 3% cover), display only, not
  // editable. Clients pick the currency; Medicys owns the rate.
  const rateCls = dark
    ? "text-sm font-mono text-white tabular-nums"
    : "text-[11px] font-mono tabular-nums text-stone-700 group-hover:text-[#1B4F8A] transition-colors";
  const optionBg = dark ? "bg-[#0B1220]" : "bg-white text-stone-800";
  const formattedRate = Number(rate || 0).toFixed(4);
  return (
    <div className={wrapCls} data-testid="currency-switcher">
      <span className={labelCls}>{dark ? "£ GBP →" : "Convert to"}</span>
      <select
        value={value}
        onChange={(e) => onCurrencyChange(e.target.value)}
        className={selectCls}
        data-testid="currency-select"
      >
        <option value="GBP" className={optionBg}>GBP</option>
        <option value="USD" className={optionBg}>USD</option>
        <option value="EUR" className={optionBg}>EUR</option>
        <option value="CAD" className={optionBg}>CAD</option>
        <option value="AUD" className={optionBg}>AUD</option>
        <option value="CHF" className={optionBg}>CHF</option>
        <option value="DKK" className={optionBg}>DKK</option>
        <option value="JPY" className={optionBg}>JPY</option>
      </select>
      {!isGBP && (
        <>
          <span className={atCls}>@</span>
          {loading ? (
            <span
              className={
                dark
                  ? "text-xs font-mono text-stone-400 animate-pulse"
                  : "text-[11px] font-mono text-stone-500 animate-pulse"
              }
              data-testid="currency-rate-loading"
            >
              fetching…
            </span>
          ) : (
            <span
              className={rateCls}
              title="Live ECB mid-market rate, refreshed every 12 hours"
              data-testid="currency-rate-display"
            >
              {formattedRate}
            </span>
          )}
        </>
      )}
    </div>
  );
}
